<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">No Show Fee List</h2>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">No Show Fee List</h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search records"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </base-input>
            </div>
            <el-table :data="queriedData">
              <el-table-column
                :min-width="200"
                align="left"
                label="User"
              >
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div>{{ props.row.Users ? props.row.Users.email : "" }}</div>
                      <div>
                        {{ props.row.Users ? props.row.Users.first_name + " " + props.row.Users.last_name : "" }}
                      </div>
                    </div>
                  </div>
                </div>
              </el-table-column>

              <el-table-column
                :min-width="200"
                align="left"
                label="Event"
              >
                <div slot-scope="props">
                  <div>
                    <div>{{ props.row.Events ? props.row.Events.event_name : '' }}</div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="200" align="left" label="Status">
                <div slot-scope="props">
                  <div>
                    <div>{{ props.row.status }}</div>
                  </div>
                </div>
              </el-table-column>

              <el-table-column :min-width="200" align="left" label="No Show Fee">
                <div slot-scope="props">
                  <div>
                    <div>{{ props.row.late_fee }}</div>
                  </div>
                </div>
              </el-table-column>



               <el-table-column
                :min-width="200"
                align="left"
                label="Is Payment Charged?"
              >
                <div slot-scope="props">
                  <div>
                    <div>
                      {{
                        props.row.is_fake_charge_by_admin
                          ? "Admin skipped charge"
                          : "Payment Charged"
                      }}
                    </div>
                  </div>
                </div>
              </el-table-column>



               <el-table-column
                :min-width="200"
                align="left"
                label="Description"
              >
                <div slot-scope="props">
                  <div>
                    <div>{{ props.row.description ? props.row.description : '' }}</div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="200" align="left" label="Date">
                <div slot-scope="props">
                  <div>
                    <div>{{ formatDateTime(props.row.created_at) }}</div>
                  </div>
                </div>
              </el-table-column>

            <el-table-column :min-width="200" align="left" label="Control">
            <div slot-scope="props">
              <button
                class="btn btn-fill"
                @click="removeClickhandler(props.row._id)"
              >
              Remove
              </button>
              </div>
              </el-table-column> 
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <div class="row loader-pos">
      <div class="sk-chase" v-if="loading">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>

      <div class="no-data-message" v-if="noDataMessage">
        <div>There are no records found</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "src/components";
import Fuse from "fuse.js";
import swal from "sweetalert2";
import { Modal, BaseAlert } from "src/components";

export default {
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    BaseAlert,
  },
        // Remove misplaced line, move logic to computed property
  computed: {
    /***
     * Returns tableData with computed label for search and display
     */
    tableDataWithLabels() {
      return this.tableData.map(row => ({
        ...row,
        payment_charge_status_label: row.is_fake_charge_by_admin ? 'Admin skipped charge' : 'Payment Charged'
      }));
    },
    queriedData() {
      let result = this.tableDataWithLabels;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      noDataMessage: "",
      loading: false,
      modals_classic: false,
      actions: [],
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["name", "email", "age", "salary", ],
      tableColumns: [
        {
          prop: "name",
          label: "Name",
          minWidth: 200,
        },
        {
          prop: "email",
          label: "Email",
          minWidth: 250,
        },
        {
          prop: "age",
          label: "Age",
          minWidth: 100,
        },
        {
          prop: "salary",
          label: "Salary",
          minWidth: 120,
        },
      ],
      tableData: [],
      tableDatas: [],
      searchedData: [],
      fuseSearch: null,
      currentOrder: {},
        // Search keys for all displayed table columns
        searchKeys: [
          "Users.first_name",
          "Users.last_name",
          "Users.email",
          "Events.event_name",
          "status",
          "late_fee",
          "payment_charge_status_label",
          "description",
          "created_at"
        ],
    };
  },
  async mounted() {
    this.loading = true;
    let test = await this.$apiService.getCall("late-fee/all-late-fee");
    console.log(test);
    this.tableDatas = test.apidata.Data || [];
    this.tableData =  this.tableDatas.reverse();
    console.log(this.tableData);
    // Fuse search initialization.
    // Use dot notation for all displayed fields, and use tableDataWithLabels for search
    this.fuseSearch = new Fuse(this.tableDataWithLabels, {
      keys: this.searchKeys,
      threshold: 0.3,
      ignoreLocation: true,
    });
    this.loading = false;
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableDataWithLabels;
      console.log("search ");
      console.log(this.searchQuery);
      if (this.searchQuery !== "") {
        // Use Fuse.js to search nested user fields and computed label
        result = this.fuseSearch.search(this.searchQuery).map(a => a.item);
      }
      this.searchedData = result;
    },
  },
  methods: {
    formatDateTime(datetime) {
      return moment(datetime).format('DD-MM-YYYY hh:mm a')
    }, 
    async removeClickhandler(id) { 
		let confirmed = confirm("Are you sure you want to delete this Records? ");
		if (confirmed === true) {
			this.loading = true;
			let latefee = await this.$apiService.postCall(`late-fee/delete/${id}`);
			if(latefee.apidata.Data && latefee.apidata.Data._id) {
			  this.tableData = this.tableData.filter((item) => item._id !== id);
			  await this.$apiService.notify("The record is deleted successfully!");
			} else {
			  await this.$apiService.notify("Something went wrong. Please contact support.");
			}
			this.loading = false;
	    }
    },
  },
};
</script>
<style>
.pagination-select,
.search-input {
  width: 200px;
}
.swal2-icon-content {
  font-size: inherit !important;
}
</style>
